import React from 'react';

import styles from './style.module.css';

interface ScrollDownMarkProps {
  count?: number; // 화살표 개수
  size?: number; // 화살표 크기
  color?: string; // 화살표 색상
  gap?: number; // 화살표 간격
  delay?: number; // 화살표 지연 시간
}

const ScrollDownMark = ({
  count = 3,
  size = 12,
  color = '#fff',
  gap = 10,
  delay = 0.15,
}: ScrollDownMarkProps) => {
  return (
    <section className={styles.scrollDownMark}>
      <div className={styles.scrollDownButton}>
        {Array.from({ length: count }).map((_, index) => {
          return (
            <span
              key={index}
              style={{
                width: size,
                height: size,
                borderColor: color,
                top: index * gap,
                WebkitAnimationDelay: `${index * delay}s`,
                animationDelay: `${index * delay}s`,
              }}
            ></span>
          );
        })}
      </div>
    </section>
  );
};

export default ScrollDownMark;
